export default "__VITE_ASSET__DpwiUuA6__"